import styled from 'styled-components';

export const IconWrapper = styled.div`
  flex-shrink: 0;
  line-height: 0;
  color: var(--blue-400);
`;

export const LabelAndBadgeWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  gap: 16px;
  overflow: hidden;
`;

export const LabelWrapper = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const shouldForwardProp = (prop) => !['activeClassName'].includes(prop);

export const Wrapper = styled('a').withConfig({ shouldForwardProp })`
  min-height: 40px;
  max-width: 250px;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 18px;
  border-radius: 4px;
  color: var(--coolGray-600);
  font: inherit;
  cursor: pointer;
  transition: all 250ms ease, font-weight 0ms;

  &:hover,
  &:focus {
    background: var(--blue-25);
    text-decoration: none;
  }

  &.active,
  &.active-descendant {
    color: var(--blue-900);
    font-weight: 600;

    ${IconWrapper} {
      color: var(--blue-700);
    }
  }

  &.active {
    background: var(--blue-50);
  }
`;

export const Badge = styled.div``;
